import './modal.scss';
import React, { memo, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button, Switch, Submenu, Icon, useTheme } from '..';
const Modal = _ref => {
  let {
    type,
    className,
    children,
    isOpen,
    onClose,
    title,
    showCancel,
    cancelBtnIcon,
    cancelBtnTitle,
    cancelBtnLoading,
    disabledCancel,
    onCancelClick,
    showSubmit,
    submitBtnColor,
    submitBtnIcon,
    submitBtnTitle,
    submitLoading,
    onSubmitClick,
    disabled,
    deleteBtn,
    activeTabIndex,
    customBtnElement,
    expandedHeader,
    footerMessage,
    headerDesc,
    headerImg,
    menuItems,
    onShowSelection,
    selectedItemsCount,
    selectionBtnTitle,
    setActiveTabIndex,
    submitBtnLabel,
    subtitle,
    toggleAction,
    preventOutsideClose,
    customHeader,
    customImageElement,
    imgModalUrl,
    imgBgColor,
    additionalBtn,
    customFooter,
    clearState
  } = _ref;
  const {
    theme
  } = useTheme();
  const modalNode = useRef();
  const [activate, setActivate] = useState(false);
  const [opened, setOpened] = useState(false);
  useEffect(() => {
    let openTimeout, closeTimeout;
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      openTimeout = setTimeout(() => {
        setActivate(isOpen);
      }, 100);
      setOpened(true);
    } else {
      setActivate(false);
      closeTimeout = setTimeout(() => {
        setOpened(false);
      }, 200);
    }
    return () => {
      clearTimeout(openTimeout);
      clearTimeout(closeTimeout);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);
  useEffect(() => {
    document.addEventListener('keydown', closeModal, false);
    return () => {
      document.removeEventListener('keydown', closeModal);
    };
  }, [isOpen]);
  useEffect(() => {
    if (!isOpen && opened && clearState) {
      setTimeout(() => {
        clearState();
      }, 200);
    }
  }, [isOpen, opened]);
  const closeModal = e => {
    if (e.key === 'Escape' && onClose && isOpen) onClose();
  };
  const handleClickOutside = e => {
    if (preventOutsideClose) return;
    const hasActiveDropdown = document.getElementsByClassName('dropdown-options-wrap active');
    const {
      current: modalBodyEl
    } = modalNode || {};
    if (isOpen && modalBodyEl && modalBodyEl.contains(e.target) || modalBodyEl && modalBodyEl.classList.contains('dropdown') || hasActiveDropdown.length) {
      return;
    }
    onClose && onClose();
  };
  return opened && /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-modal', {
      'wrts-img-modal': type === 'image',
      scrollable: type === 'scrollable',
      active: activate
    }, className, theme)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-modal-wrap', {
      'without-footer': !selectedItemsCount && !showCancel && !showSubmit && !customFooter
    }),
    ref: modalNode
  }, type === 'image' && /*#__PURE__*/React.createElement("div", {
    className: "wrts-modal-img-wrap",
    style: {
      backgroundColor: imgBgColor
    }
  }, imgModalUrl && /*#__PURE__*/React.createElement("img", {
    src: imgModalUrl,
    alt: title,
    className: "img"
  }), customImageElement && customImageElement()), /*#__PURE__*/React.createElement("div", {
    className: "wrts-modal-body-wrap"
  }, /*#__PURE__*/React.createElement("header", {
    className: classNames('wrts-modal-header', {
      expanded: expandedHeader
    })
  }, !expandedHeader ? title && /*#__PURE__*/React.createElement("h2", {
    className: "wrts-modal-title"
  }, title) : /*#__PURE__*/React.createElement("div", {
    className: "header-content"
  }, headerImg && /*#__PURE__*/React.createElement("img", {
    src: headerImg,
    className: "img",
    alt: "illustration"
  }), subtitle && /*#__PURE__*/React.createElement("h5", {
    className: "wrts-modal-subtitle"
  }, subtitle), title && /*#__PURE__*/React.createElement("h2", {
    className: "wrts-modal-title"
  }, title), headerDesc && /*#__PURE__*/React.createElement("p", {
    className: "desc"
  }, headerDesc)), customHeader, onClose && /*#__PURE__*/React.createElement(Button, {
    className: "close",
    type: "icon-link",
    iconName: "close",
    onClick: onClose
  }), !!menuItems.length && /*#__PURE__*/React.createElement(Submenu, {
    menuItems: menuItems,
    onChange: setActiveTabIndex,
    focusItemIndex: activeTabIndex
  })), /*#__PURE__*/React.createElement("div", {
    className: "wrts-modal-body"
  }, children), (selectedItemsCount || showCancel || showSubmit || customFooter) && /*#__PURE__*/React.createElement("footer", {
    className: "wrts-modal-footer"
  }, customFooter, toggleAction && /*#__PURE__*/React.createElement(Switch, {
    title: toggleAction.title,
    onChange: toggleAction.onChange,
    checked: toggleAction.checked,
    label: toggleAction.label,
    disabled: toggleAction.disabled,
    onClick: toggleAction.onClick || undefined
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames('btn-group', {
      'space-between': selectedItemsCount || footerMessage,
      right: !selectedItemsCount
    })
  }, !!selectedItemsCount && /*#__PURE__*/React.createElement(Button, {
    className: "btn",
    type: "link",
    title: selectionBtnTitle,
    onClick: onShowSelection
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "expand-more"
  })), footerMessage && /*#__PURE__*/React.createElement("span", {
    className: "message"
  }, footerMessage), /*#__PURE__*/React.createElement("div", {
    className: "btn-group"
  }, showCancel && /*#__PURE__*/React.createElement(Button, {
    className: classNames('btn', {
      disabled: disabledCancel
    }),
    color: "grey",
    title: cancelBtnTitle,
    onClick: onCancelClick,
    iconName: cancelBtnIcon,
    dataName: "cancel-btn-modal",
    loading: cancelBtnLoading
  }), additionalBtn && /*#__PURE__*/React.createElement(Button, {
    className: `btn ${additionalBtn.classname || ''}`,
    type: additionalBtn.type,
    title: additionalBtn.title,
    onClick: additionalBtn.onclick,
    iconName: additionalBtn.icon || ''
  }), showSubmit && (customBtnElement || /*#__PURE__*/React.createElement(Button, {
    className: classNames('btn', {
      disabled,
      red: deleteBtn
    }),
    label: submitBtnLabel,
    type: "primary",
    title: submitBtnTitle,
    iconName: submitBtnIcon || '',
    color: submitBtnColor,
    onClick: onSubmitClick,
    loading: submitLoading
  }))))))));
};
Modal.defaultProps = {
  type: 'default',
  isOpen: false,
  showCancel: true,
  showSubmit: true,
  menuItems: [],
  onCancelClick: () => {},
  onSubmitClick: () => {}
};
Modal.propTypes = {
  type: PropTypes.oneOf(['default', 'scrollable', 'image']),
  className: PropTypes.string,
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  showCancel: PropTypes.bool,
  cancelBtnIcon: PropTypes.string,
  cancelBtnTitle: PropTypes.string,
  cancelBtnLoading: PropTypes.bool,
  disabledCancel: PropTypes.bool,
  onCancelClick: PropTypes.func,
  showSubmit: PropTypes.bool,
  submitBtnColor: PropTypes.string,
  submitBtnIcon: PropTypes.string,
  submitBtnTitle: PropTypes.string,
  submitLoading: PropTypes.bool,
  onSubmitClick: PropTypes.func,
  disabled: PropTypes.bool,
  deleteBtn: PropTypes.bool,
  activeTabIndex: PropTypes.number,
  customBtnElement: PropTypes.node,
  expandedHeader: PropTypes.bool,
  footerMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  headerDesc: PropTypes.string,
  headerImg: PropTypes.string,
  menuItems: PropTypes.array,
  onShowSelection: PropTypes.func,
  selectedItemsCount: PropTypes.number,
  selectionBtnTitle: PropTypes.string,
  setActiveTabIndex: PropTypes.func,
  submitBtnLabel: PropTypes.string,
  subtitle: PropTypes.string,
  toggleAction: PropTypes.object,
  preventOutsideClose: PropTypes.bool,
  customHeader: PropTypes.node,
  customImageElement: PropTypes.func,
  imgModalUrl: PropTypes.string,
  imgBgColor: PropTypes.string,
  additionalBtn: PropTypes.object,
  customFooter: PropTypes.node,
  clearState: PropTypes.func
};
export default /*#__PURE__*/memo(Modal);